import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "backdrop"];

  connect() {
    document.body.classList.add("overflow-hidden");
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden");
  }

  close(e) {
    if (e) e.preventDefault();
    this.element.remove();
  }

  handleKeyup(e) {
    if (e.code == "Escape") {
      this.close();
    }
  }

  clickOutside(event) {
    if (event.target.closest('[data-modal-target="container"]')) {
      return;
    }

    this.close();
  }
}
